import Modal from 'react-responsive-modal';
import alert from '../../../../assets/images/alert.png';
import { Button } from '../../../../components/Button';
import styles from './style.module.css';

interface IModalLeadExists {
  modalIsOpen: boolean;
  toggleModal: () => void;
  messageRegisterLead: any;
  player: any;
  client: any;
}

export function ModalLeadExists({
  messageRegisterLead,
  modalIsOpen,
  toggleModal,
}: IModalLeadExists) {
  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <div className="contents-modal">
        <div className="d-flex justify-content-center">
          <img
            className={styles.alert}
            src={alert}
            alt="Dados já existentes."
          />
        </div>
        <h1 className="title-modal">Ops! Usuário já cadastrado!</h1>
        <p className="subtitle-modal">
          {messageRegisterLead && messageRegisterLead}
          {!messageRegisterLead &&
            `Seus dados já estão na plataforma. Logo entraremos em contato!`}
        </p>
      </div>
      <div className={styles.contentBtn}>
        <Button
          isModal
          text="fechar"
          type="button"
          color="primary"
          onClick={() => {
            toggleModal();
          }}
        />
      </div>
    </Modal>
  );
}
